import { render, staticRenderFns } from "./Template-08.vue?vue&type=template&id=9a248e16&scoped=true&"
import script from "./Template-08.vue?vue&type=script&lang=js&"
export * from "./Template-08.vue?vue&type=script&lang=js&"
import style0 from "./Template-08.vue?vue&type=style&index=0&id=9a248e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a248e16",
  null
  
)

export default component.exports